import _ from "underscore";

function min(...args) {
  args.pop();
  return Math.min(..._.flatten(args).map(value => parseFloat(value)));
}

export default min;
